export default "__VITE_ASSET__FFvNhOqA__"